document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('a[href^="#"]').forEach(function (link) {
    link.addEventListener('click', function (event) {
      var selector = this.getAttribute('href');
      if (!selector || selector === '#') return;
      var target = document.querySelector(selector);
      if (target) {
        event.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  document.querySelectorAll('.theme-product-thumbs img').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var main = document.querySelector('.product-main-image');
      if (!main) return;
      var oldSrc = main.getAttribute('src');
      main.setAttribute('src', this.getAttribute('src'));
      main.removeAttribute('srcset');
      main.removeAttribute('sizes');
      this.setAttribute('src', oldSrc);
    });
    thumb.setAttribute('role', 'button');
    thumb.setAttribute('tabindex', '0');
  });
});
